/**
 * SSOT — official HotelsRiver platform logo.
 * Agent / public-site custom logos override via normalizeAgentImageValue.
 */
import officialLogoUrl from "../assets/images/hotelsriver-logo-BB0w6TYN.jpg";
import { normalizeAgentImageValue } from "./resolveAgentCompanyLogoUrl";

/** Vite-resolved URL (or dev path) for <img src> */
export const HOTELSRIVER_OFFICIAL_LOGO_URL = officialLogoUrl;

/**
 * Production/CDN URL — print HTML, emailed previews; matches deployed /public/assets.
 */
export const HOTELSRIVER_OFFICIAL_LOGO_ABSOLUTE_URL =
  "https://www.hotelsriver.com/assets/hotelsriver-logo-BB0w6TYN.jpg";

/**
 * @param {unknown} agentLogoRaw e.g. companylogobase65
 * @param {{ forExternalDocument?: boolean }} [opts] When true, HotelsRiver fallback is the public absolute URL (print/PDF/new window HTML).
 * @returns {string}
 */
export function resolveBrandedCompanyLogoUrl(agentLogoRaw, opts = {}) {
  const agent = normalizeAgentImageValue(agentLogoRaw);
  if (agent) return agent;
  if (opts.forExternalDocument) return HOTELSRIVER_OFFICIAL_LOGO_ABSOLUTE_URL;
  return HOTELSRIVER_OFFICIAL_LOGO_URL;
}
